import { render, staticRenderFns } from "./testItem-add-or-update.vue?vue&type=template&id=547a017a&scoped=true&"
import script from "./testItem-add-or-update.vue?vue&type=script&lang=js&"
export * from "./testItem-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a017a",
  null
  
)

export default component.exports